import React from 'react';
import {Link} from 'react-router-dom';

import {Container, Row, Col, Button} from 'react-bootstrap';

import {ReactComponent as ImgVl2} from '../../../asset/img/vl/2.svg';
import {ReactComponent as ImgVl4} from '../../../asset/img/vl/4.svg';
import {ReactComponent as ImgVl5} from '../../../asset/img/vl/5.svg';

import * as IconFi from 'react-icons/fi';

import './Box.scss'

const Box = () => {

    const items = [
        {id: 1, title: 'خرید کنید', to: '/shop', img: './img/page/home/box/shop.jpg', class: 'accent-3', vl: <ImgVl5 className="img-fluid"/>},
        {id: 2, title: 'میل کنید', to: '/dine', img: './img/page/home/box/dine.jpg', class: 'accent-4', vl: <ImgVl2 className="img-fluid"/>},
        {id: 3, title: 'تفریح کنید', to: '/entertain', img: './img/page/home/box/entertain.jpg', class: 'accent-2', vl: <ImgVl4 className="img-fluid"/>},
    ]

    // -----------------------------------------------------------------------------------------------------------------

    return (
        <Container fluid="lg" as="section" id="box" className="mt-5 pt-sm-2">
            <Row className="g-0">
                <h2 className="fs-5 fw-normal mb-3 pb-1 d-none d-md-block">در میکا مال</h2>
                {
                    items.map(item => {
                        return (
                            <Col lg={4} key={item.id} className={`box-${item.id}`}>
                                <Link to={item.to} className={`d-block text-decoration-none ratio ratio-1x1 text-white`}>
                                    <span className="d-flex flex-column">
                                        <figure className={`mb-0 overflow-hidden bg-${item.class} filter-color flex-grow-1 position-relative`}>
                                            <span className="filter-level"/>
                                            <img src={item.img} alt="" className="h-100 w-100 object-fit-cover"/>
                                            {/*<span className={`filter-gradient filter-gradient-${item.class}`}/>*/}
                                        </figure>
                                        <span className={`d-flex align-items-end p-4 h1 lh-1 mb-0 fw-bold bg-${item.class} flex-shrink-0 overflow-hidden position-relative ls-half`}>
                                            {item.title}
                                            <Button as="span" variant={`outline-light`} className="btn-icon ms-auto d-none d-sm-inline-flex d-lg-none">
                                                <IconFi.FiArrowLeft size={24} className="sw-1"/>
                                            </Button>
                                            {/*<span className={`d-sm-none position-absolute vl`}>{item.vl}</span>*/}
                                        </span>
                                    </span>
                                </Link>
                            </Col>
                        )
                    })
                }
            </Row>
        </Container>
    )
}

export default Box;